export default "__VITE_ASSET__949018ad__"